/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:51b2b801-7646-416a-83d3-20b34eecda1d",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_z7gLkAeZI",
    "aws_user_pools_web_client_id": "bis9psdnpi2sjnh4qgmkjv72t",
    "oauth": {
        "domain": "s3uploaderuie85366ea-e85366ea-dev.auth.eu-west-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://S3uploadTestSRE.sre.ipsen.digital/index.html/",
        "redirectSignOut": "https://S3uploadTestSRE.sre.ipsen.digital/index.html/",
        "responseType": "token"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://lxey2fdq5l.execute-api.eu-west-1.amazonaws.com/dev",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "s3uploaderui7076b81c392349f5aa0ec72a0b73407395128-dev",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_content_delivery_bucket": "s3uploaderui-20220516154706-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d2s7esd2ewonwg.cloudfront.net"
};


export default awsmobile;
